import { SharedProgrammeCatalogueLayout } from '@/components/layout/SharedProgrammeCataloguePage';
import { BASE_REVALIDATE } from '@/lib/constants';
import {
  allProgrammesQuery,
  navigationQuery,
  pageQuery,
  siteSettingsQuery,
} from '@/lib/queries';
import { getClient, readToken } from '@/lib/sanityUtils';
import { getValidLocale } from '@/lib/utils';

import type {
  SanityNavigationType,
  SanityPageType,
  SanityProgrammeType,
  SanitySiteSettingsType,
} from '@/types/sanity';
import type { GetStaticProps } from 'next';

const slug = 'programmes';

export const getStaticProps = (async ({ locale, draftMode = false }) => {
  const client = getClient(draftMode ? { token: readToken } : undefined);

  const validLocale = getValidLocale(locale);

  if (!validLocale) {
    return {
      notFound: true,
    };
  }
  const programmesPage = await client.fetch<SanityPageType>(
    pageQuery({ locale: validLocale, slug }),
  );

  const siteSettings = await client.fetch<SanitySiteSettingsType>(
    siteSettingsQuery({ locale: validLocale }),
  );

  const programmes = await client.fetch<SanityProgrammeType[]>(
    allProgrammesQuery({ region: validLocale }),
  );

  const navigation = await client.fetch<SanityNavigationType>(
    navigationQuery({ locale: validLocale }),
  );

  return {
    props: {
      programmesPage,
      programmes,
      siteSettings,
      locale: validLocale,
      draftMode,
      slug,
      navigation,
      token: draftMode ? readToken : '',
    },
    revalidate: Number(process.env.REVALIDATE || BASE_REVALIDATE),
  };
}) satisfies GetStaticProps;

export default SharedProgrammeCatalogueLayout;
